import { atomWithReset } from 'jotai/utils';

export const tourAtom = atomWithReset(false);